const team2026 = {
  title: "2026",
  members: [
    {
      name: "message.team.management",
      members: [
        {
          img: "/static/team/members/2025/David_Casavant.jpg",
          fullName: "David Casavant",
          role: "message.team.roles.captain",
          mail: "d.casavant.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/david-casavant-b67152252/",
        },
        {
          img: "/static/team/members/2025/Maxim_Brasseur.jpg",
          fullName: "Maxim Brasseur",
          role: "message.team.roles.technical-director",
          mail: "m.brasseur.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/maximbrasseur/",
        },
        {
          img: "/static/team/members/2025/Thomas_Lefebvre.jpg",
          fullName: "Thomas Lefebvre",
          role: "message.team.roles.technical-director",
          mail: "t.lefebvre.formule.ets@gmail.com",
          linkedin: "https://ca.linkedin.com/in/thomas-lefebvre-31a161253/",
        },
        {
          img: "/static/team/members/2025/Alexandre_Remillard.jpg",
          fullName: "Alexandre Rémillard",
          role: "message.team.roles.treasurer",
          mail: "a.remillard.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/alexandre-r%C3%A9millard-68b686260/",
        },
      ],
    },
    {
      name: "message.team.aerodynamic",
      members: [
        {
          img: "/static/team/members/2025/Maxence_Wolf.jpg",
          fullName: "Maxence Wolf",
          role: "message.team.roles.lead-aerodynamics",
          mail: "m.wolf.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/maxence-wolf-17480b252/",
        },
        {
          img: "/static/team/members/2025/William_Lecavalier.jpg",
          fullName: "William Lecavalier",
          role: "",
          mail: "w.lecavalier.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/william-lecavalier/",
        },
        {
          img: "/static/team/members/2025/Guillaume_Beaufort-Samson.jpg",
          fullName: "Guillaume Beaufort-Samson",
          role: "",
          mail: "g.beaufortsamson.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/guillaume-beaufort-samson-3110952a/",
        },
        {
          img: "/static/team/members/2025/Casque_Homme.jpg",
          fullName: "Martin Jehan",
          role: "",
          mail: "",
          linkedin: "https://www.linkedin.com/in/martin-jehan-3502b4291/",
        },
        {
          img: "/static/team/members/2025/Casque_Homme.jpg",
          fullName: "Ethan Pichon",
          role: "",
          mail: "ethan.pichon@formule-ets.ca",
          linkedin: "https://www.linkedin.com/in/etpichon/",
        },
        {
          img: "/static/team/members/2025/Casque_Homme.jpg",
          fullName: "Maxence Vitte",
          role: "",
          mail: "maxence.vitte@formule-ets.ca",
          linkedin: "https://www.linkedin.com/in/maxence-vitte-258abb29a/",
        },
      ],
    },
    {
      name: "message.team.chassis",
      members: [
        {
          img: "/static/team/members/2025/Sebastian_Arancibia_Saldana.jpg",
          fullName: "Sebastian Arancibia Saldana",
          role: "message.team.roles.lead-chassis",
          mail: "s.arancibiasaldana.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/sebastian-arancibia-saldana/",
        },
        {
          img: "/static/team/members/2025/Etienne_Paillereau.jpg",
          fullName: "Etienne Paillereau",
          role: "",
          mail: "e.paillereau.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/etienne-paillereau-746855203",
        },
        {
          img: "/static/team/members/2025/Pauline_Gillet.jpg",
          fullName: "Pauline Gillet",
          role: "",
          mail: "pauline.gillet@formule-ets.ca",
          linkedin: "https://www.linkedin.com/in/paulinegillet6/",
        },
        {
          img: "/static/team/members/2025/Thomas_Joly.jpg",
          fullName: "Thomas Joly",
          role: "",
          mail: "t.joly.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/thomasjoly002/",
        },
        {
          img: "/static/team/members/2025/Christian-Martin_Al-Jiries.jpg",
          fullName: "Christian-Martin Al-Jiries",
          role: "",
          mail: "cm.aljiries.formule.ets@gmail.com",
          linkedin: "",
        },
        {
          img: "/static/team/members/2025/Casque_Femme.jpg",
          fullName: "Khadji Aboubakar Hassan",
          role: "",
          mail: "khadji.aboubakar-hassan.1@ens.etsmtl.ca",
          linkedin: "https://www.linkedin.com/in/aboubakarhassankhadji/",
        },
        {
          img: "/static/team/members/2025/Casque_Homme.jpg",
          fullName: "Lucas Chauveau",
          role: "",
          mail: "lucas.chauveau@formule-ets.ca",
          linkedin: "https://www.linkedin.com/in/lucas-chauveau/",
        },
        {
          img: "/static/team/members/2025/Casque_Homme.jpg",
          fullName: "Noah Niang",
          role: "",
          mail: "noah.niang@formule-ets.ca",
          linkedin: "https://www.linkedin.com/in/noah-niang-b2bab9306/",
        },
        {
          img: "/static/team/members/2025/Casque_Homme.jpg",
          fullName: "Florian Gueant",
          role: "",
          mail: "florian.gueant@formule-ets.ca",
          linkedin: "https://www.linkedin.com/in/florian-gu%C3%A9ant-7809a2333/",
        },
      ],
    },
    {
      name: "message.team.dynamics",
      members: [
        {
          img: "/static/team/members/2025/Juliette_Dubois.jpg",
          fullName: "Juliette Dubois",
          role: "message.team.roles.lead-dynamic",
          mail: "j.dubois.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/juliette-dubois-09002a373/",
        },
        {
          img: "/static/team/members/2025/Maxim_Brasseur.jpg",
          fullName: "Maxim Brasseur",
          role: "",
          mail: "m.brasseur.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/maximbrasseur/",
        },
        {
          img: "/static/team/members/2025/Thomas_Lefebvre.jpg",
          fullName: "Thomas Lefebvre",
          role: "",
          mail: "t.lefebvre.formule.ets@gmail.com",
          linkedin: "https://ca.linkedin.com/in/thomas-lefebvre-31a161253/",
        },
        {
          img: "/static/team/members/2025/Louis-David_Boudrias.jpg",
          fullName: "Louis-David Boudrias",
          role: "",
          mail: "ld.boudrias.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/louis-david-boudrias/",
        },
        {
          img: "/static/team/members/2025/Casque_Homme.jpg",
          fullName: "Dorian Roubert",
          role: "",
          mail: "dorian.roubert@formule-ets.ca",
          linkedin: "https://www.linkedin.com/in/dorian-roubert/",
        },
      ],
    },
    {
      name: "message.team.electronics",
      members: [
        {
          img: "/static/team/members/2025/Casque_Homme.jpg",
          fullName: "Vincent Gonthier",
          role: "message.team.roles.lead-electronic",
          mail: "vincent.gonthier@formule-ets.ca",
          linkedin: "https://www.linkedin.com/in/vincent-gonthier38/",
        },
        {
          img: "/static/team/members/2025/Shawn_Killeen.jpg",
          fullName: "Shawn Killeen",
          role: "",
          mail: "s.killeen.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/shawnkilleen/",
        },
        {
          img: "/static/team/members/2025/Raphael_Roumat.jpg",
          fullName: "Raphaël Roumat",
          role: "",
          mail: "r.roumat.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/rapha%C3%ABl-roumat-5a3015253/",
        },
        {
          img: "/static/team/members/2025/Koraly_Lemieux.jpg",
          fullName: "Koraly Lemieux",
          role: "",
          mail: "koraly.lemieux@formule-ets.ca",
          linkedin: "https://www.linkedin.com/in/koraly-lemieux-194904263/",
        },
        {
          img: "/static/team/members/2025/Casque_Homme.jpg",
          fullName: "Maxence Cossette",
          role: "",
          mail: "maxence.cossette@formule-ets.ca",
          linkedin: "https://www.linkedin.com/in/maxence-cossette-a81b71277/",
        },
        {
          img: "/static/team/members/2025/Casque_Homme.jpg",
          fullName: "Massimo Faulkner",
          role: "",
          mail: "massimo.faulkner@formule-ets.ca",
          linkedin: "",
        },
        {
          img: "/static/team/members/2025/Casque_Homme.jpg",
          fullName: "Mohamed Houssem Meddah",
          role: "",
          mail: "mohamed-houssem.meddah@formule-ets.ca",
          linkedin: "https://www.linkedin.com/in/mohamed-houssem-meddah/",
        },
        {
          img: "/static/team/members/2025/Casque_Homme.jpg",
          fullName: "Alexandre Ronet",
          role: "",
          mail: "alexandre.ronet@formule-ets.ca",
          linkedin: "https://www.linkedin.com/in/alexandre-ronet-6a5905159/",
        },
        {
          img: "/static/team/members/2025/Casque_Homme.jpg",
          fullName: "Hussein Saab",
          role: "",
          mail: "hussein.saab@formule-ets.ca",
          linkedin: "https://www.linkedin.com/in/hussein-saab-/",
        },
      ],
    },
    {
      name: "message.team.drivetrain",
      members: [
        {
          img: "/static/team/members/2025/Maxim_Brasseur.jpg",
          fullName: "Maxim Brasseur",
          role: "message.team.roles.lead-drivetrain",
          mail: "m.brasseur.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/maximbrasseur/",
        },
        {
          img: "/static/team/members/2025/David_Casavant.jpg",
          fullName: "David Casavant",
          role: "",
          mail: "d.casavant.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/david-casavant-b67152252/",
        },
        {
          img: "/static/team/members/2025/Laurent_Drewitt.jpg",
          fullName: "Laurent Drewitt",
          role: "",
          mail: "laurent.drewitt@formule-ets.ca",
          linkedin: "https://www.linkedin.com/in/laurent-drewitt-1278b434a/",
        },
        {
          img: "/static/team/members/2024/Martin_Lex.jpg",
          fullName: "Martin Lex",
          role: "",
          mail: "m.lex.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/martin-lex-b9a896150/",
        },
        {
          img: "/static/team/members/2025/Koraly_Lemieux.jpg",
          fullName: "Koraly Lemieux",
          role: "",
          mail: "koraly.lemieux@formule-ets.ca",
          linkedin: "https://www.linkedin.com/in/koraly-lemieux-194904263/",
        },
        {
          img: "/static/team/members/2025/Casque_Homme.jpg",
          fullName: "Sacha Edmond-Renaud",
          role: "",
          mail: "sacha.edmond-renaud@formule-ets.ca",
          linkedin: "",
        },
        {
          img: "/static/team/members/2025/Casque_Homme.jpg",
          fullName: "Adam Mc Manaman",
          role: "",
          mail: "",
          linkedin: "https://www.linkedin.com/in/adam-mc-manaman-38003b36a/",
        },
      ],
    },
    {
      name: "message.team.powertrain",
      members: [
        {
          img: "/static/team/members/2025/Melina_Gasparini.jpg",
          fullName: "Mélina Gasparini",
          role: "message.team.roles.lead-powertrain",
          mail: "m.gasparini.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/melina-gasparini-cpi-cep-631991141/",
        },
        {
          img: "/static/team/members/2025/Alexy_Cabeceiras.jpg",
          fullName: "Alexy Cabeceiras",
          role: "",
          mail: "alexy.cabeceiras@formule-ets.ca",
          linkedin: "https://ca.linkedin.com/in/alexy-cabeceiras-107b01354",
        },
        {
          img: "/static/team/members/2025/Jean-Francois_Perna.jpg",
          fullName: "Jean-François Perna",
          role: "",
          mail: "jf.perna.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/jean-fran%C3%A7ois-perna-996b27373/",
        },
        {
          img: "/static/team/members/2025/David_Casavant.jpg",
          fullName: "David Casavant",
          role: "",
          mail: "d.casavant.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/david-casavant-b67152252/",
        },
        {
          img: "/static/team/members/2025/Casque_Homme.jpg",
          fullName: "Édouard Godbout",
          role: "",
          mail: "edouard.godbout@formule-ets.ca",
          linkedin: "",
        },
        {
          img: "/static/team/members/2025/Casque_Homme.jpg",
          fullName: "Justin Thériault",
          role: "",
          mail: "justin.theriault@formule-ets.ca",
          linkedin: "",
        },
      ],
    },
    {
      name: "message.team.machining",
      members: [
        {
          img: "/static/team/members/2025/Louis-David_Boudrias.jpg",
          fullName: "Louis-David Boudrias",
          role: "message.team.roles.lead-machining",
          mail: "ld.boudrias.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/louis-david-boudrias/",
        },
        {
          img: "/static/team/members/2025/Maxim_Brasseur.jpg",
          fullName: "Maxim Brasseur",
          role: "",
          mail: "m.brasseur.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/maximbrasseur/",
        },
        {
          img: "/static/team/members/2025/Thomas_Lefebvre.jpg",
          fullName: "Thomas Lefebvre",
          role: "",
          mail: "t.lefebvre.formule.ets@gmail.com",
          linkedin: "https://ca.linkedin.com/in/thomas-lefebvre-31a161253/",
        },
        {
          img: "/static/team/members/2025/Laurent_Drewitt.jpg",
          fullName: "Laurent Drewitt",
          role: "",
          mail: "l.drewitt.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/laurent-drewitt-1278b434a/",
        },
      ],
    },
    {
      name: "message.team.driverless",
      members: [
        {
          img: "/static/team/members/2025/Nicolas_Gaulin-Metivier.jpg",
          fullName: "Nicolas Gaulin-Métivier ",
          role: "message.team.roles.lead-driverless",
          mail: "n.gaulinmetivier.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/nicolas-gaulin-m%C3%A9tivier-50850a258/",
        },
        {
          img: "/static/team/members/2025/Casque_Homme.jpg",
          fullName: "Victor Dang",
          role: "",
          mail: "victor.dang@formule-ets.ca",
          linkedin: "",
        },
        {
          img: "/static/team/members/2025/Casque_Homme.jpg",
          fullName: "Dalil Merad",
          role: "",
          mail: "",
          linkedin: "https://www.linkedin.com/in/dalil-merad/",
        },
        {
          img: "/static/team/members/2025/Casque_Femme.jpg",
          fullName: "Leelou Lebrun",
          role: "",
          mail: "",
          linkedin: "https://www.linkedin.com/in/leelou-lebrun/",
        },
        {
          img: "/static/team/members/2025/Casque_Homme.jpg",
          fullName: "Loïck Ivoula",
          role: "",
          mail: "",
          linkedin: "https://www.linkedin.com/in/lo%C3%AFck-ivoula/",
        },
        {
          img: "/static/team/members/2025/Casque_Homme.jpg",
          fullName: "Mehdi Ben Nasrallah",
          role: "",
          mail: "mehdi.ben-nasrallah@formule-ets.ca",
          linkedin: "https://www.linkedin.com/in/mehdi-ben-94b927152/",
        },
        {
          img: "/static/team/members/2025/Casque_Femme.jpg",
          fullName: "Nada Yassine",
          role: "",
          mail: "",
          linkedin: "https://www.linkedin.com/in/nada-yassine-aab843299/",
        },
        {
          img: "/static/team/members/2024/Casque_Homme.jpg",
          fullName: "Zakari Oulounis",
          role: "",
          mail: "z.oulounis.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/zakari-oulounis-201542145/",
        },
      ],
    },
    {
      name: "message.team.external_relationship",
      members: [
        {
          img: "/static/team/members/2025/Gabriel_Lecavalier.jpg",
          fullName: "Gabriel Lecavalier",
          role: "message.team.roles.lead-external-relationship",
          mail: "gabriel.lecavalier@formule-ets.ca",
          linkedin: "https://www.linkedin.com/in/gabriel-lecavalier-174501282/",
        },
        {
          img: "/static/team/members/2025/Melina_Gasparini.jpg",
          fullName: "Mélina Gasparini",
          role: "",
          mail: "m.gasparini.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/melina-gasparini-cpi-cep-631991141/",
        },
        {
          img: "/static/team/members/2025/Alexandre_Remillard.jpg",
          fullName: "Alexandre Rémillard",
          role: "",
          mail: "a.remillard.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/alexandre-r%C3%A9millard-68b686260/",
        },
        {
          img: "/static/team/members/2025/Guillaume_Do_Khoa_Nguyen.jpg",
          fullName: "Guillaume Do Khoa Nguyen",
          role: "",
          mail: "guillaume.nguyen@formule-ets.ca",
          linkedin: "https://www.linkedin.com/in/guillaume-do-khoa-nguyen/",
        },
        {
          img: "/static/team/members/2025/Lyza_Yacini.jpg",
          fullName: "Lyza Yacini",
          role: "",
          mail: "",
          linkedin: "https://www.linkedin.com/in/lyza-yacini-763866346/",
        },
        {
          img: "/static/team/members/2025/Casque_Homme.jpg",
          fullName: "Quentin Delétoille",
          role: "",
          mail: "quentin.deletoille@formule-ets.ca",
          linkedin: "https://www.linkedin.com/in/quentin-deletoille-860621338/",
        },
        {
          img: "/static/team/members/2025/Casque_Homme.jpg",
          fullName: "Luc Afonso",
          role: "",
          mail: "luc.afonso@formule-ets.ca",
          linkedin: "https://www.linkedin.com/in/luc-afonso/",
        },
        {
          img: "/static/team/members/2025/Casque_Homme.jpg",
          fullName: "Adam Mc Manaman",
          role: "",
          mail: "",
          linkedin: "https://www.linkedin.com/in/adam-mc-manaman-38003b36a/",
        },
      ],
    },
    {
      name: "message.team.statics",
      members: [
        {
          img: "/static/team/members/2025/Alexandre_Remillard.jpg",
          fullName: "Alexandre Rémillard",
          role: "message.team.roles.lead-business",
          mail: "a.remillard.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/alexandre-r%C3%A9millard-68b686260/",
        },
        {
          img: "/static/team/members/2025/Koraly_Lemieux.jpg",
          fullName: "Koraly Lemieux ",
          role: "message.team.roles.lead-cost",
          mail: "koraly.lemieux@formule-ets.ca",
          linkedin: "https://www.linkedin.com/in/koraly-lemieux-194904263/",
        },
      ],
    },
  ],
};

export default team2026;
